import {AccountCheckEnum}          from '@/app/account/shared/enum/account-check.enum';
import {AccountCreateEnum}         from '@/app/account/create/enum/account-create.enum';
import {AccountFindEnum}           from '@/app/account/find/enum/account-find.enum';
import {AccountAuthEnum}           from '@/app/account/shared/enum/account-auth.enum';

import {LayoutEnum}                from '@/app/layout/enum/layout.enum';
import {CoreEnum}                  from '@/app/shared/enum/core.enum';
import {AccountRecantEnum}         from '@/app/account/recant/enum/account-recant.enum';
import {AccountConsentEnum}        from '@/app/account/consent/enum/account-consent.enum';
import {AccountSocialTransferEnum} from '@/app/account/social-transfer/enum/account-social-transfer.enum';

export namespace Enum {
  export namespace ACCOUNT {
    export import CHECK    = AccountCheckEnum;
    export import CREATE   = AccountCreateEnum;
    export import FIND     = AccountFindEnum;
    export import AUTH     = AccountAuthEnum;
    export import RECANT   = AccountRecantEnum;
    export import CONSENT  = AccountConsentEnum;
  }

  export namespace SOCIAL_TRANSFER {
    export import CREATE   = AccountCreateEnum;
    export import FIND     = AccountFindEnum;
    export import AUTH     = AccountAuthEnum;
    export import CHECK    = AccountCheckEnum;
    export import TRANSFER = AccountSocialTransferEnum;
  }

  export import LAYOUT = LayoutEnum;
  export import CORE = CoreEnum;
}
